import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-classic-conclave',
  templateUrl: './classic-conclave.component.html',
  styleUrls: ['./classic-conclave.component.scss']
})
export class ClassicConclaveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit(){
  
    
}

}
